import { render, staticRenderFns } from "./PublicHolidayDrawer.vue?vue&type=template&id=bdec3768&scoped=true"
import script from "./PublicHolidayDrawer.vue?vue&type=script&lang=js"
export * from "./PublicHolidayDrawer.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayDrawer.vue?vue&type=style&index=0&id=bdec3768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdec3768",
  null
  
)

export default component.exports